export default "__VITE_ASSET__CWmOu4$Q__"